import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.darkGrey,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 50
  const h = 50
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width="48"
          height="48"
          rx="24"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M20.5 22.75L25 27.25L29.5 22.75"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          id="arrow"
        />
      </svg>
    </svg>
  )
}

export default SvgComponent
